import { TableCollapsable } from '@octano/global-ui';
import { useTranslation } from 'react-i18next';
import { Card, Col, Row } from 'reactstrap';
import { TranslationsKeys } from '../../../locales/translations';
import { useColumns } from '../hooks/useColumns';
import AnnouncementDetails from './AnnouncementDetails';
import { useAnnouncementListLoader } from './Loaders/AnnouncementListLoader';

const AnnouncementTable = () => {
  const { t } = useTranslation(
    TranslationsKeys.MANAGEMENT_TOOLS_ANNOUNCEMENTS_LIST,
  );

  const { data, loading } = useAnnouncementListLoader();

  const columns = useColumns();

  return (
    <>
      <div className="mx-3">
        <Card className="p-4">
          <Row>
            <Col xs={12}>
              <p className="fs-14 W-100">{t(`description`)}</p>
            </Col>
            <Col xs={12} className="mt-4">
              <TableCollapsable
                columns={columns}
                data={data || []}
                isLoading={loading}
                noResultsText={t('empty')}
                secondColumn={{
                  columnName: 'second',
                  headerText: 'second',
                  cellFormat: ({ row }) => (
                    <AnnouncementDetails
                      announcement={row}
                      showTargets={false}
                      translationKey={
                        TranslationsKeys.MANAGEMENT_TOOLS_ANNOUNCEMENTS_LIST
                      }
                    />
                  ),
                }}
              />
            </Col>
          </Row>
        </Card>
      </div>
    </>
  );
};

export default AnnouncementTable;
